export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/403-5f732dcc3fc51b221dfd62bbc35a9106.png";